import React from 'react';
import type { ContactMethod } from '@/types';
import styles from './ContactSection.module.css';

interface ContactSectionProps {
  contactMethods: ContactMethod[];
}

export const ContactSection: React.FC<ContactSectionProps> = ({ contactMethods }) => {
  return (
    <section id="contact" className={styles.contactSpread}>
      <h2 className={styles.contactTitle}>Låt oss skapa</h2>
      <p className={styles.contactSubtitle}>Berättelser som gör skillnad</p>

      <div className={styles.contactGrid}>
        {contactMethods.map((method, index) => (
          <div key={index} className={styles.contactMethod}>
            <h3 className={styles.methodTitle}>{method.title}</h3>
            <p className={styles.methodValue}>{method.value}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
